var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoEntradaInactivo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Picto Entrada Inactivo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PICTOGRAMAS",
    transform: "translate(-71.000000, -166.000000)",
    stroke: "#31383E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto-Entrada-Inactivo",
    transform: "translate(72.000000, 167.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.87663749,3.28853924 C2.87663749,1.47229557 4.29116132,3.60759494e-05 6.03617975,3.60759494e-05 L10.4298343,3.60759494e-05 C12.1748527,3.60759494e-05 13.5895498,1.47229557 13.5895498,3.28853924 L13.5895498,8.63499494 C13.5895498,10.4512386 12.1748527,11.9234981 10.4298343,11.9234981 L6.03617975,11.9234981",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3715861,9.42426456 L11.6836861,9.42426456 L11.6836861,7.7378943 C11.6836861,7.7378943 10.645063,6.26779937 8.60941037,6.26779937 C8.60941037,6.26779937 7.69539436,4.92739747 6.24135676,4.62472025 L3.54107548,4.62472025 C3.54107548,4.62472025 2.50245244,4.79752405 1.04841484,6.22450823 L0.259005864,6.22450823 C0.259005864,6.22450823 0.00979179077,6.65687848 0.00979179077,8.04057152 C0.00979179077,8.04057152 -0.156408693,9.42426456 0.882214352,9.42426456 L1.27683219,9.42426456",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6448858,9.42426456 L8.00353248,9.42426456",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-7",
    points: "7.82007072 6.48394842 7.36306271 6.74333449 3.41636446 6.74333449 2.85554615 6.15962563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6448858,9.42426456 C3.6448858,10.1048373 3.11474265,10.656619 2.46085899,10.656619 C1.80697534,10.656619 1.27683219,10.1048373 1.27683219,9.42426456 C1.27683219,8.74369177 1.80697534,8.19191013 2.46085899,8.19191013 C3.11474265,8.19191013 3.6448858,8.74369177 3.6448858,9.42426456 Z",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3715861,9.42426456 C10.3715861,10.1048373 9.84144294,10.656619 9.18755929,10.656619 C8.53367563,10.656619 8.00353248,10.1048373 8.00353248,9.42426456 C8.00353248,8.74369177 8.53367563,8.19191013 9.18755929,8.19191013 C9.84144294,8.19191013 10.3715861,8.74369177 10.3715861,9.42426456 Z",
    id: "Stroke-11"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoEntradaInactivo);
export default __webpack_public_path__ + "static/media/PictoEntradaInactivo.8c1972dff963a9d9ed34f8fdea7c51f2.svg";
export { ForwardRef as ReactComponent };